<script>

    import { toast } from 'bulma-toast'
    import { modalStore, prepaidsStore, prepaidStore } from '../stores'

    import Providers from '../$components/providers.svelte'
    import PrepaidsService from '../$services/prepaids.service'

    import Date from '../$components/date.svelte'
    import Form from '../$components/form.svelte'

    import InputText from '../$components/input.text.svelte'
    import InputNumber from '../$components/input.number.svelte'

    import ButtonModal from '../$components/button.modal.svelte'
    import Button from '../$components/button.svelte'

    let data = new Object({
        _id: $prepaidStore._id,
        provider: $prepaidStore.provider,
        service: $prepaidStore.service,
        volumetricMin: $prepaidStore.volumetricMin,
        volumetricMax: $prepaidStore.volumetricMax,
        shipmentsTotal: $prepaidStore.shipmentsTotal,
        expired: $prepaidStore.expired,
    })
    
    let loading = false

    async function updatePrepaid() {

        loading = true
        const resp = await PrepaidsService.updatePrepaid(data._id, data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        prepaidsStore.replace(resp.data)
        prepaidStore.set(resp.data)

        toast({message: 'Prepago actualizado', type: 'is-success'})
        
        modalStore.set('prepaid_modal')
    }

</script>

<Form on:submit={updatePrepaid} { loading } >
    <div class="columns">
        <div class="column">
            <Providers bind:provider={data.provider} bind:service={data.service} />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={data.volumetricMin} label="Peso mínimo" placeholder="Peso mínimo (kg)" />
        </div>
        <div class="column">
            <InputText bind:value={data.volumetricMax} label="Peso máximo" placeholder="Peso máximo (kg)" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputNumber bind:value={data.shipmentsTotal} label="Cantidad de guías" placeholder="Cantidad de guías" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Date bind:value={data.expired} label="Fecha de expiración" />
        </div>
    </div>
    <div class="items-end">
        <div class="buttons">
            <ButtonModal modalId="prepaid_modal" text="Cancelar" icon="ban" color="light" />
            <Button type="submit" text="Guardar" icon="save" color="primary" { loading } />
        </div>
    </div>
</Form>